import { createFileRoute } from "@tanstack/react-router";
import Home from "@realtorSitesClient/pages/Home";

export const Route = createFileRoute("/")({
  component: Home,
});
